export default __webpack_public_path__ + "static/media/acceso-camara-windows-1.16f76441.svg";